import type { IRecord } from '@platform/core/types';

/** Поточне значення поля для форми: чернетка має пріоритет над записом; title/status — з конверта, решта — values або ext. */
export function valueOf(record: IRecord | undefined, draft: Record<string, unknown>, key: string): unknown {
  if (key in draft) return draft[key];
  if (!record) return undefined;
  if (key === 'title') return record.title;
  if (key === 'status') return record.status;
  return record.values[key] ?? record.ext[key];
}
